import { Action } from '@ngrx/store'
import * as mapAnalyticsTypes from './map-analytics.types'

export class FetchDashboardsRequest implements Action {
  readonly type = mapAnalyticsTypes.FETCH_DASHBOARDS_REQUEST
  constructor() {}
}

export class FetchDashboardsSuccess implements Action {
  readonly type = mapAnalyticsTypes.FETCH_DASHBOARDS_SUCCESS
  constructor(public payload: any) {}
}

export class FetchDashboardsFailure implements Action {
  readonly type = mapAnalyticsTypes.FETCH_DASHBOARDS_FAILURE
  constructor(public payload: any) {}
}

export class FetchDashboardDataRequest implements Action {
  readonly type = mapAnalyticsTypes.FETCH_DASHBOARD_DATA_REQUEST
  constructor(public key: string, public payload: any) {}
}

export class FetchDashboardDataSuccess implements Action {
  readonly type = mapAnalyticsTypes.FETCH_DASHBOARD_DATA_SUCCESS
  constructor(public payload: any) {}
}

export class FetchDashboardDataFailure implements Action {
  readonly type = mapAnalyticsTypes.FETCH_DASHBOARD_DATA_FAILURE
  constructor(public payload: any) {}
}

// Common

export class UpdateField implements Action {
  readonly type = mapAnalyticsTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class SetDefaultData implements Action {
  readonly type = mapAnalyticsTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export type Actions =
  | FetchDashboardsRequest
  | FetchDashboardsSuccess
  | FetchDashboardsFailure
  | FetchDashboardDataRequest
  | FetchDashboardDataSuccess
  | FetchDashboardDataFailure
  | SetDefaultData
  | UpdateField
